import { IWebLink } from '../../../../../types';

const addHardcodedLinks = ( managedLinks?: IWebLink[]): IWebLink[] => [
  {
    id: 0,
    children: [
      {
        id: 10,
        label: 'Gift Sets',
        url: '/categories/gift-sets',
      },
      {
        id: 11,
        label: 'Sauces',
        url: '/categories/sauces',
      },
      {
        id: 12,
        label: 'Limited Reserve',
        url: '/categories/limited-reserve',
      },
      {
        id: 13,
        label: 'Soups',
        url: '/categories/soups',
      },
      {
        id: 14,
        label: 'Pastas',
        url: '/categories/pastas',
      },
      {
        id: 15,
        label: 'All Products',
        url: '/categories/all-products',
      },
    ],
    label: 'Shop Online',
  },
  ...managedLinks,
  {
    id: 1,
    children: [
      {
        id: 20,
        label: 'About',
        url: 'https://www.raos.com/pages/about',
      },
      {
        id: 21,
        label: 'Sauce 101',
        url: 'https://www.raos.com/pages/sauce-101',
      },
      {
        id: 22,
        label: 'News',
        url: 'https://www.raos.com/pages/news',
      },
    ],
    label: 'About',
  },
];

export default addHardcodedLinks;
